import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { SupabaseService } from '../service/supabase.service';
import { CompanyUser } from '../interface/user.interface';


export const companyUserResolver: ResolveFn<CompanyUser | null> = async (route, state) => {
  
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  const currentCompanyUser = await supabaseService.getCompanyUser();
  //console.log("From Resolver",currentCompanyUser);
  
  if(!currentCompanyUser) {
    router.navigate(['/onboard'])
    return null;
  }
  return currentCompanyUser;
};
